import PropTypes from 'prop-types';

import { AGGREGATED_FIELD_STATE } from '../../../../store/products/helpers/aggregatedFieldState';

export const aggregatedFieldStatsPropType = PropTypes.shape({
  applicableCount: PropTypes.number,
  withValueCount: PropTypes.number,
  emptyCount: PropTypes.number,
});

export const aggregatedFieldStatePropType = PropTypes.oneOf(
  Object.values(AGGREGATED_FIELD_STATE),
);

export const aggregatedStringFieldPropType = PropTypes.shape({
  state: aggregatedFieldStatePropType,
  value: PropTypes.string,
  stats: aggregatedFieldStatsPropType,
});

export const aggregatedBooleanFieldPropType = PropTypes.shape({
  state: aggregatedFieldStatePropType,
  value: PropTypes.bool,
  stats: aggregatedFieldStatsPropType,
});

export const aggregatedCategoryFieldPropType = PropTypes.shape({
  state: aggregatedFieldStatePropType,
  value: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    fullName: PropTypes.string,
  }),
  stats: aggregatedFieldStatsPropType,
});

export const aggregatedKeywordsFieldPropType = PropTypes.shape({
  state: aggregatedFieldStatePropType,
  items: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    label: PropTypes.string,
  })),
  stats: aggregatedFieldStatsPropType,
});

export const aggregatedPricingFieldsPropType = PropTypes.shape({
  price: aggregatedStringFieldPropType,
  compareAtPrice: aggregatedStringFieldPropType,
  taxable: aggregatedBooleanFieldPropType,
  cost: aggregatedStringFieldPropType,
});

export const aggregatedShippingFieldsPropType = PropTypes.shape({
  requiresShipping: aggregatedBooleanFieldPropType,
  weightValue: aggregatedStringFieldPropType,
  weightUnit: aggregatedStringFieldPropType,
  countryCodeOfOrigin: aggregatedStringFieldPropType,
  harmonizedSystemCode: aggregatedStringFieldPropType,
});

export const aggregatedInventoryFieldsPropType = PropTypes.shape({
  sku: aggregatedStringFieldPropType,
  barcode: aggregatedStringFieldPropType,
  tracked: aggregatedBooleanFieldPropType,
  countryCodeOfOrigin: aggregatedStringFieldPropType,
  harmonizedSystemCode: aggregatedStringFieldPropType,
});

export const aggregatedSeoFieldsPropType = PropTypes.shape({
  handle: aggregatedStringFieldPropType,
  seoTitle: aggregatedStringFieldPropType,
  seoDescription: aggregatedStringFieldPropType,
});

export const aggregatedMetaFieldPropType = PropTypes.shape({
  state: aggregatedFieldStatePropType,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.array,
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      currency: PropTypes.string,
    }),
  ]),
  stats: aggregatedFieldStatsPropType,
  id: PropTypes.string,
  title: PropTypes.string,
});

export const aggregatedMetaFieldsPropType = PropTypes.objectOf(
  aggregatedMetaFieldPropType,
);
